import { useState } from "react";
import { deleteProvincia, getProvinciasPanel } from "../../services/ProvinciasServices";
import { ProvinciasContext } from "./ProvinciasContext"

export const ProvinciasState = ({ children }) => {
    const getProvinciasPanelData = async (search,numpag,filas) => {
        let res = await getProvinciasPanel(search,numpag,filas)
        return res
    }

    const deleteProvinciaData = async (body,search,numpag,filas) => {
        const res = await deleteProvincia(body,search,numpag,filas)
        if (res) getProvinciasPanelData(search,numpag,filas)
        return res
    }


    return <ProvinciasContext.Provider value={{
        deleteProvinciaData,
        getProvinciasPanelData,
    }} >
        {children}
    </ProvinciasContext.Provider>
}